// test2224
(2224 && 0);
